module.exports = __webpack_public_path__ + "img/bell.5221ed7c.png";